import { createContext } from 'react';
import { Clipboard } from '../../../types';

export const ClipboardContext = createContext<Clipboard | undefined>(undefined);
